<div class="reward-card-slim-root">
  <div class="image-container">
    <div *ngIf="reward?.imgSource" class="image-wrapper">
      <img
        [src]="reward?.imgSource"
        [alt]="rewardLabels.rewardImageTitle"
        [title]="rewardLabels.rewardImageTitle"
        (error)="handleImageError()"
      />
      <div class="heart">
        <app-icon-click class="reward-card-slim-favorite" small
          >favorite_outline</app-icon-click
        >
      </div>
    </div>
    <div class="default-image" *ngIf="!reward?.imgSource">
      <nb-icon icon="printer-outline"></nb-icon>
    </div>
  </div>

  <div class="content">
    <span class="title">{{ reward?.name }}</span>
  </div>

  <div class="footer">
    <app-sticker-icon small icon="stars">{{
      reward?.cost | number: '':language
    }}</app-sticker-icon>
    <app-chip
      small
      filled
      blue
      (selectFilterClick)="onRoute()"
      id="{{ 'reward-details-button-' + index }}"
    >
      {{ rewardLabels.rewardDetails }}
    </app-chip>
  </div>
</div>
